var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _g, _line7, _line8, _line9, _line0, _line1, _line10, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 103,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 97,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 65 Q65 102 76 120 Q89 138 100 140 Q112 138 124 120 Q135 102 132 65 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67 Q68 104 79 122 Q92 140 103 142 Q115 140 127 122 Q138 104 135 67 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74 Q44 80 43 96 Q42 112 68 108",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76 Q47 82 46 98 Q45 114 71 110",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132 70 Q150 68 152 86 Q154 104 132 104",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 72 Q153 70 155 88 Q157 106 135 106",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 140,
    width: 12,
    height: 18,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5,
    transform: "rotate(-2 99 149)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 142,
    width: 12,
    height: 18,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    transform: "rotate(-2 99 149)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 157,
    width: 58,
    height: 11,
    rx: 3,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 159,
    width: 58,
    height: 11,
    rx: 3,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 78,
    x2: 82,
    y2: 112,
    stroke: "#CD7F32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 70,
    x2: 92,
    y2: 118,
    stroke: "#E8A050",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 68,
    x2: 104,
    y2: 118,
    stroke: "#CD7F32",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 70,
    x2: 116,
    y2: 114,
    stroke: "#A0622A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 72,
    x2: 95,
    y2: 120,
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 70,
    x2: 109,
    y2: 118,
    stroke: "#FF00FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 100 44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 28 L103 40 L116 41 L107 49 L109 62 L100 55 L91 63 L92 49 L83 42 L96 41 Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 30 L106 42 L119 43 L110 51 L112 64 L103 57 L94 65 L95 51 L86 44 L99 43 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 28 L103 40 L116 41 L107 49 L109 62 L100 55 L91 63 L92 49 L83 42 L96 41 Z",
    fill: "#CD7F32",
    opacity: 0.55
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 56,
    x2: 46,
    y2: 56,
    stroke: "#CD7F32",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 51,
    x2: 41,
    y2: 61,
    stroke: "#CD7F32",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 153,
    y1: 46,
    x2: 163,
    y2: 46,
    stroke: "#E8A050",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: 41,
    x2: 158,
    y2: 51,
    stroke: "#E8A050",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 144,
    x2: 46,
    y2: 144,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 140,
    x2: 42,
    y2: 148,
    stroke: "#00FFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 193,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#CD7F32",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3
  }, "BRONZE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 195,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#00CCCC",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3,
    opacity: 0.45
  }, "BRONZE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.5f485280a16a6bce62eb2e1509985272.svg";
export { ForwardRef as ReactComponent };